"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionMenuSelectMultipleAssigned = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const action_menu_select_multiple_available_1 = require("./action-menu-select-multiple-available");
exports.ActionMenuSelectMultipleAssigned = (0, styled_components_1.default)(action_menu_select_multiple_available_1.ActionMenuSelectMultipleAvailable) `
  margin-top: 26px;
`;
//# sourceMappingURL=action-menu-select-multiple-assigned.js.map